import { ALL_JOB_SWMS_URL } from "../../dataProvider/constant";
import { scopeApiInstance } from "../../dataProvider/axiosHelper";
import { Strings } from "../../dataProvider/localize";

const USE_MOCK = process.env.NODE_ENV !== "production"
  && process.env.REACT_APP_USE_EMERGENCY_MOCKS === "true";

const SAMPLE_PROCEDURE = {
  id: 9,
  procedure_id: "PR-009",
  title: "Pick-Off Rescue - Descent to Casualty",
  revision: 1,
  status: "approved",
  status_label: "Approved",
  active: true,
  emergency_plans_count: 0,
  approver: "7666793086",
  approver_name: "Yash Tandon",
  approver_job_title: "Manager 2",
  pending_approval_by: null,
  pending_approval_by_name: null,
  message: "asdad",
  approved_at: "2026-09-04T22:11:58.000Z",
  submitted_by: "7666793086",
  submitted_by_name: "Yash Tandon",
  submit_message: null,
  submitted_at: "2026-09-04T22:11:45.000Z",
  created_by: "4585037894",
  created_by_name: "Sumeet Kasar",
  created_by_job_title: "Site Farm Supervisor",
  created_at: "2026-09-03T16:35:10.000Z",
  modified_by: "7666793086",
  modified_by_name: "Yash Tandon",
  modified_at: "2026-09-04T17:35:24.000Z",
  section_order: [
    "procedure_application",
    "use_when",
    "do_not_use_when",
    "rescue_configuration_media",
    "perform_rescue",
    "stop_escalate",
    "after_recovery"
  ],
  sections: [
    {
      id: "after_recovery",
      type: "after_recovery",
      display_name: "After Recovery",
      data: {
        toggle: 1,
        content: {
          html: "<p>Return to the Emergency Plan for casualty care, emergency-services handover, scene control, notifications and post-rescue actions.</p>\n"
        }
      }
    },
    {
      id: "do_not_use_when",
      type: "do_not_use_when",
      display_name: "Do Not Use This Procedure When",
      data: {
        toggle: 1,
        content: {
          html: "<ul>\n<li>The control point, anchor, structure or system integrity is uncertain.</li>\n<li>The casualty cannot be safely reached, stabilised or secured.</li>\n<li>The minimum team, equipment, route or required redundancy cannot be maintained.</li>\n</ul>\n"
        }
      }
    },
    {
      id: "perform_rescue",
      type: "perform_rescue",
      display_name: "Perform the Rescue",
      data: {
        phases: [
          {
            name: "Confirm and Prepare",
            steps: [
              "Approach or descend to the casualty using the approved trained method.",
              "Verify the independent rescue system, control point, route and recovery area."
            ]
          },
          {
            name: "Reach and Secure the Casualty",
            steps: [
              "Approach or descend to the casualty using the approved trained method.",
              "Stabilize the casualty and establish the approved casualty connection and required redundancy."
            ]
          },
          {
            name: "Transfer and Recover",
            steps: [
              "Transfer the load under control. Release or bypass the original system only after control is confirmed.",
              "Descend or transfer the casualty under continuous control to the nominated safe recovery point.",
              "Transfer the casualty to the First Aider and return command to the Emergency Plan."
            ]
          }
        ],
        toggle: 1
      }
    },
    {
      id: "procedure_application",
      type: "procedure_application",
      display_name: "Procedure Application",
      data: {
        scenario: {
          text: "Suspended worker cannot self-descend and can be safely reached from above.",
          html: "<p>Suspended worker cannot self-descend and can be safely reached from above.</p>\n<p></p>\n"
        },
        toggle: 1,
        objective: {
          text: "Recover the casualty to the nominated safe recovery point using the approved pick-off method while maintaining continuous control and required redundancy.",
          html: "<p>Recover the casualty to the nominated safe recovery point using the approved pick-off method while maintaining continuous control and required redundancy.</p>\n"
        }
      }
    },
    {
      id: "rescue_configuration_media",
      type: "rescue_configuration_media",
      display_name: "Rescue Configuration Photos & Attachments",
      data: {
        attachments: [
          {
            file_name: {
              visible_name: "wallpaper_1.webp",
              type: "image/webp",
              isUploaded: true,
              originFileObj: {},
              file_name: "swms/masters/emergency-procedures/1788504375041-wallpaper_1.webp",
              isFailed: false
            },
            note: "Controlled technical diagram inherited from the Procedure Master.",
            title: "Approved Master Configuration"
          },
          {
            file_name: {
              isUploaded: true,
              originFileObj: {},
              type: "application/pdf",
              visible_name: "J1040-job_cleaning_report.pdf",
              isFailed: false,
              file_name: "swms/masters/emergency-procedures/1788505203255-J1040-job_cleaning_report.pdf"
            },
            note: "Full technical details and data for the procedure.",
            title: "Details of the Approved Plan"
          }
        ],
        toggle: 1
      }
    },
    {
      id: "stop_escalate",
      type: "stop_escalate",
      display_name: "Stop & Escalate",
      data: {
        toggle: 1,
        content: {
          html: "<p>If the connection, transfer, control point, route, minimum team or redundancy cannot be maintained, stop and secure the casualty where safe. Use another approved Procedure only when its selection conditions are met; otherwise request specialist rescue.</p>\n"
        }
      }
    },
    {
      id: "use_when",
      type: "use_when",
      display_name: "Use This Procedure When",
      data: {
        toggle: 1,
        content: {
          html: "<ul>\n<li>The worker cannot self-descend and can be safely reached from above.</li>\n<li>An independent verified rescue system, route and recovery area are available.</li>\n<li>The approved casualty connection and controlled transfer can be achieved.</li>\n</ul>\n"
        }
      }
    }
  ]
};

const getMockEmergencyProcedures = () => {
  const secondProcedure = JSON.parse(JSON.stringify(SAMPLE_PROCEDURE));
  secondProcedure.id = 10;
  secondProcedure.procedure_id = "PR-010";
  secondProcedure.title = "Pick-Off Rescue - Assisted Recovery";
  secondProcedure.revision = 2;
  secondProcedure.emergency_plans_count = 1;
  secondProcedure.section_order = [...SAMPLE_PROCEDURE.section_order];
  secondProcedure.sections = secondProcedure.sections.map((section) => ({
    ...section,
    data: {
      ...section.data,
      toggle: section.data.toggle
    }
  }));

  return Promise.resolve({
    exists: true,
    toggle: 1,
    document: {
      procedures: [SAMPLE_PROCEDURE, secondProcedure]
    }
  });
};

export const getJobSwmsEmergencyProcedures = (abortController, swmsId, jobId) => () => {
  if (swmsId === undefined || swmsId === null || `${swmsId}`.trim() === "" || jobId === undefined || jobId === null || `${jobId}`.trim() === "") {
    return Promise.reject(Strings.generic_error);
  }

  if (USE_MOCK) {
    return getMockEmergencyProcedures();
  }

  return scopeApiInstance.get(`${ALL_JOB_SWMS_URL}/${jobId}/${swmsId}/emergency-procedures`, { ...abortController })
    .then((res) => {
      if (res && res.data && res.data.data) {
        return Promise.resolve(res.data.data);
      }

      return Promise.reject(Strings.generic_error);
    })
    .catch((error) => Promise.reject(
      error && error.response && error.response.data && error.response.data.message
        ? error.response.data.message
        : Strings.network_error
    ));
};

export const saveJobSwmsEmergencyProcedures = (jobId, swmsId, proceduresPayload) => () => {
  if (swmsId === undefined || swmsId === null || `${swmsId}`.trim() === "" || jobId === undefined || jobId === null || `${jobId}`.trim() === "") {
    return Promise.reject(Strings.generic_error);
  }

  if (USE_MOCK) {
    return Promise.resolve({
      message: "Emergency Procedures saved successfully.",
      emergency_procedures: proceduresPayload,
      version_created: false
    });
  }

  return scopeApiInstance.put(
    `${ALL_JOB_SWMS_URL}/${jobId}/${swmsId}/emergency-procedures`,
    { emergency_procedures: proceduresPayload }
  ).then((res) => {
    if (res && res.data && res.data.data) {
      return Promise.resolve(res.data.data);
    }

    return Promise.reject(Strings.generic_error);
  }).catch((error) => Promise.reject(
    error && error.response && error.response.data && error.response.data.message
      ? error.response.data.message
      : Strings.network_error
  ));
};
